import { competitionsB2CRApi } from 'entities/competitions-b2cr';
import { toast } from 'react-toastify';
import { ErrorMessageDataType } from 'shared/types';
import { KPIList } from '../types';

const getMechanicsApi = competitionsB2CRApi.injectEndpoints({
  endpoints: (builder) => ({
    getKPIList: builder.query<KPIList, any>({
      query: () => ({ url: '/kpi-calendar/admin/kpi_names/' }),
      providesTags: (result, error) => {
        const errorMessageStandart = 'Возникла ошибка при получении KPI.';
        const errorMessageNotFound = 'KPI для соревнования не найдены.';
        if (error) {
          if (error.status === 500) {
            toast.error(errorMessageStandart.toString(), {
              position: toast.POSITION.TOP_RIGHT,
            });
          } else if (error.status === 404) {
            toast.error(errorMessageNotFound.toString(), {
              position: toast.POSITION.TOP_RIGHT,
            });
          } else {
            toast.error((error.data as ErrorMessageDataType).detail, {
              position: toast.POSITION.TOP_RIGHT,
            });
          }
        }
        return ['KPIList'];
      },
    }),
  }),
});

export const { useGetKPIListQuery } = getMechanicsApi;
